import { render, staticRenderFns } from "./viewmain.vue?vue&type=template&id=5d9933a3&scoped=true&"
import script from "./viewmain.vue?vue&type=script&lang=js&"
export * from "./viewmain.vue?vue&type=script&lang=js&"
import style0 from "./viewmain.vue?vue&type=style&index=0&id=5d9933a3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d9933a3",
  null
  
)

export default component.exports